<template>
<main class="bg-main lesson-quiz lesson-multiaudio">
  <contenthead :section="sectionData" :lesson="lessonData"></contenthead>

  <section class="container">

     <div class="heading-content-title">{{ $t('lesson.review.title') }}</div>

     <lessonmultiaudio v-if="introductionData.content.slide && audioType" :key="$route.params.lesson_id" :audioList="introductionData.content.slide" :audioType="audioType"></lessonmultiaudio>

      <div class="buttons-side-by-side">
        <a class="button button-default back" @click="back">{{ $t('common.button.back') }}</a>
        <a class="button button-primary next" @click="nextStep">{{ $t('common.button.next') }}</a>
      </div>

  </section>

</main>
</template>

<script>
  import status from '../../mixins/status';
  import {mapState} from 'vuex'

  import componentContentHead from '../shared/ContentHead.vue';
  import LessonMultiAudio from './LessonMultiAudio.vue'

  export default {
  name: 'LessonReview',
    mixins: [
      status
    ],
    components: {
      'contenthead': componentContentHead,
      'lessonmultiaudio': LessonMultiAudio,
    },
    data () {
      return {
        step: 'review',// Refer to the content ID of the story.
        audioType: 'slide',
      }
    },
    computed: {
      ...mapState({
        user: state => state.auth
      }),
      sectionData() {
        return this.$store.getters.section_data;
      },
      lessonData() {
        return this.$store.getters.lesson_data;
      },
      introductionData() {
        // Same content as the story.
        return this.$store.getters.lesson_content.introduction ? this.$store.getters.lesson_content.introduction : {content: { title: '', body: ''}}
      },
    },

    created() {

      if(!this.$store.getters.section_data || Object.keys(this.$store.getters.section_data).length == 0) {
        this.$router.push({name: 'lesson.introduction'});
      }
    },

    methods: {
      nextStep() {
        this.$router.push({name: 'lesson.explanation', params: {step: 'listening_practice'}});
      },
      back() {
        this.$router.push({name: 'lesson.explanation', params: {step: 'practice'}});
      }
    },
  }
</script>

